// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3TnU6","search":"Settings_search__3wxtx","filter":"Settings_filter__3lGm-"};